import { Box } from "@mui/material";
import React from "react";
export default function Loader() {
    return React.createElement(Box, { sx: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 5,
        } }, "Loading please wait...");
}
